@if (loggedInUserChanged$ | async; as loggedInUserChanged) {
  <pt-multi-login-detected
    [loggedInUserChanged]="loggedInUserChanged"
  ></pt-multi-login-detected>
} @else {
  <router-outlet></router-outlet>
}

<p-toast [style]="{ marginTop: '80px' }" position="top-center"></p-toast>
